import React from "react";
import {Bar} from "react-chartjs-2";

export default function StackedBarChart({ chartData, aspectRatio }) {
  return (
    <>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          aspectRatio: aspectRatio ?? 2,
          scales: {
            x: {
              stacked: true
            },
            y: {
              stacked: true,
              grid: {
                color: (context) => {
                  return context.tick.value === 0 ? 'rgba(128, 128, 128, 1)' : 'rgba(0, 0, 0, 0.1)';
                },
                lineWidth: (context) => {
                  return context.tick.value === 0 ? 2 : 1;
                },
              }
            }
          },
          plugins: {
            legend: {
              display: true
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  let label = context.dataset.label || '';
                  if (context.dataset.data) {
                    label += ` ${new Intl.NumberFormat('sr-RS', {
                      style: 'currency',
                      currency: 'RSD'
                    }).format(context.dataset.data[context.dataIndex] ?? 0)}`;
                  }
                  return label;
                }
              }
            }
          }
        }}
      />
    </>
  );
}
